export const statusColorTag = {
  AUTORIZADO: 'teal',
  CANCELADO: 'red',
  REEMBOLSADO: 'red',
  EXPIRADO: 'purple',
  PENDIENTE: 'orange',
  RECHAZADO: 'red-outline',
  'NO AUTORIZADO': 'grey',
  'N/A': 'grey',
};
